'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgCheckmark = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.781 5.469C20.922 5.6097 21.0013 5.80076 21.0013 6C21.0013 6.19924 20.922 6.39029 20.781 6.531L10.281 17.031C10.1403 17.1721 9.94921 17.2513 9.74997 17.2513C9.55073 17.2513 9.35968 17.1721 9.21897 17.031L3.96897 11.781C3.67571 11.4877 3.67571 11.0123 3.96897 10.719C4.26223 10.4257 4.73771 10.4257 5.03097 10.719L9.74997 15.4395L19.719 5.469C19.8597 5.32794 20.0507 5.24866 20.25 5.24866C20.4492 5.24866 20.6403 5.32794 20.781 5.469Z", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgCheckmark);

exports["default"] = ForwardRef;
//# sourceMappingURL=Checkmark.js.map
